<template>
  <div
    class="deactive-brand"
    ref="mod"
    v-show="configs.modalType == 'deactive'"
  >
    <template>
      <artmisads-modal
        :title="
          configs.activeTab == '0'
            ? $t('seller.brandsPage.modalDeactivateAttribution')
            : $t('seller.brandsPage.modalDeactivateAssociate')
        "
        v-model:open="configs.open"
        @ok="onOk"
        @cancel="onModalCancel"
        style="width: 900px"
        :getContainer="() => $refs.mod"
        :cancelText="$t('seller.common.cancel')"
        :okText="
          configs.modalType == 'deactive'
            ? $t('seller.brandsPage.deactivateBrandWithCount', {
                count:
                  configs.activeTab == '0'
                    ? item.activeProductCount
                    : item.associateActiveProductCount,
              })
            : $t('seller.common.confirm')
        "
      >
        <div class="deactive">
          <div class="top">
            <div class="top-left">
              <div
                class="brand-img-show"
                :style="
                  item?.logoImageUrl
                    ? { background: 'rgba(238, 237, 242, 1)' }
                    : ''
                "
              >
                <img :src="item.logoImageUrl" v-if="item.logoImageUrl" />
                <span class="brand-name" v-else>{{
                  item.amazonBrandName
                }}</span>
              </div>
            </div>
            <div class="top-right">
              <div class="top-right-title">
                {{ item.amazonBrandName }}
              </div>
              <div class="top-right-content">
                <div class="top-right-status">
                  <div class="top-right-status-title">{{ $t('seller.common.status') }}</div>
                  <Status
                    :type="item.status.toLowerCase()"
                    v-if="configs.activeTab == '0'"
                    :noBorder="true"
                    :text="item.status == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')"
                    style="margin-top: 4px"
                  />
                  <Status
                    :type="item.associateStatus.toLowerCase()"
                    v-if="configs.activeTab == '1'"
                    :noBorder="true"
                    :text="
                      item.associateStatus == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">{{ $t('seller.brandsPage.productsLabel') }}</div>
                  <div class="top-right-status-count">
                    {{
                      configs.activeTab == '0'
                        ? item.activeProductCount
                        : item.associateActiveProductCount
                    }}
                    <a-popover placement="bottom">
                      <template #title>
                        <div class="pop-title">
                          {{ $t('seller.brandsPage.bulkActivatePopoverBefore') }}<span
                            style="
                              color: rgba(138, 100, 244, 1);
                              font-weight: 700;
                            "
                          >
                            {{
                              configs.activeTab == '0'
                                ? item.activeProductCount
                                : item.associateActiveProductCount
                            }}
                          </span
                          >{{ $t('seller.brandsPage.bulkActivatePopoverAfter') }}
                        </div>
                      </template>
                      <Icon name="wenhao-tianchong" class="wenhao" />
                    </a-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div class="bottom">
            <div class="bottom-title">{{ $t('seller.brandsPage.importantNotice') }}</div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />
              <div>
                <p class="paragraph">
                  {{ $t('seller.brandsPage.deactivateIntro') }}
                </p>
                <p class="paragraphContent" style="margin-top: 10px">
                  <span>·</span> {{configs.activeTab == '0' ? $t('seller.brandsPage.deactivateAttributionBullet1') : $t('seller.brandsPage.deactivateAssociateBullet1')}}
                </p>
                <p class="paragraphContent" style="margin: 10px 0">
                  <span>·</span>
                  {{  configs.activeTab == '0'
            ? $t('seller.brandsPage.deactivateAttributionBullet2')
            :  $t('seller.brandsPage.deactivateAssociateBullet2')}}
                  
                </p>
                <p class="paragraphContent">
                  <span>·</span> {{ $t('seller.brandsPage.deactivateBullet3') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </artmisads-modal>
    </template>
  </div>
  <div ref="act" v-show="configs.modalType == 'active'">
    <template>
      <artmisads-modal
        v-model:open="configs.open"
        @ok="onOk"
        @cancel="onModalCancel"
        :getContainer="() => $refs.act"
        style="width: 900px"
        :title="
          configs.activeTab == '0'
            ? $t('seller.brandsPage.modalActivateAttribution')
            : $t('seller.brandsPage.modalActivateAssociate')
        "
        :ok-text="$t('seller.common.confirm')"
        :cancelText="$t('seller.common.cancel')"
      >
        <div class="active-brand">
          <div class="top">
            <div class="top-left">
              <div
                class="brand-img-show"
                :style="
                  item?.logoImageUrl
                    ? { background: 'rgba(238, 237, 242, 1)' }
                    : ''
                "
              >
                <img :src="item.logoImageUrl" v-if="item.logoImageUrl" />
                <span class="brand-name" v-else>{{
                  item.amazonBrandName
                }}</span>
              </div>
            </div>
            <div class="top-right">
              <div class="top-right-title">
                {{ item.amazonBrandName }}
              </div>
              <div class="top-right-content">
                <div class="top-right-status">
                  <div class="top-right-status-title">{{ $t('seller.common.status') }}</div>
                  <Status
                    :type="item.status.toLowerCase()"
                    v-if="configs.activeTab == '0'"
                    :noBorder="true"
                    :text="item.status == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')"
                    style="margin-top: 4px"
                  />
                  <Status
                    :type="item.associateStatus.toLowerCase()"
                    v-if="configs.activeTab == '1'"
                    :noBorder="true"
                    :text="
                      item.associateStatus == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">{{ $t('seller.brandsPage.productsLabel') }}</div>
                  <div class="top-right-status-count">
                    {{
                      configs.activeTab == '0'
                        ? item.activeProductCount
                        : item.associateActiveProductCount
                    }}
                    <a-popover placement="bottom">
                      <template #title>
                        <div class="pop-title">
                          {{ $t('seller.brandsPage.bulkActivatePopoverBefore') }}<span
                            style="
                              color: rgba(138, 100, 244, 1);
                              font-weight: 600;
                            "
                          >
                            {{
                              configs.activeTab == '0'
                                ? item.activeProductCount
                                : item.associateActiveProductCount
                            }}
                          </span
                          >{{ $t('seller.brandsPage.bulkActivatePopoverAfter') }}
                        </div>
                      </template>
                      <Icon name="wenhao-tianchong" class="wenhao" />
                    </a-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-set-commission" v-if="configs.activeTab == '0'">
          <div class="title">{{ $t('seller.brandsPage.setCommissionForAllProducts') }}</div>
          <div class="commission">
            <div class="commission-input">
              <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
              <artmisads-input-number
                :min="0"
                :max="100"
                suffix="%"
                :step="0.5"
                size="large"
                @blur="commissionBlur"
                v-model:value="commission"
               
              />
              <!-- <span v-if="showDefalutText" class="defalut-text" @click="clickDefalutText">Please enter...</span> -->
            </div>
            <span>+</span>
            <div class="fees" ref="setCommissionRef">
              <span
                >{{ $t('seller.brandsPage.artemisAdsFees') }}<a-tooltip
                  :getPopupContainer="() => $refs.setCommissionRef"
                >
                  <template #title>
                    {{ feesTooltipText }}
                  </template>
                  <Icon
                    name="wenhao-tianchong"
                    class="question-icon"
                  /> </a-tooltip
              ></span>
              <artmisads-button disabled
                >{{ fees?.toFixed(1) }}%</artmisads-button
              >
            </div>
            <span>=</span>
            <div class="total">
              <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
              <artmisads-button disabled>
                <span>{{
                  commission
                    ? parseFloat(Number(fees) + Number(commission)).toFixed(1)
                    : Number(fees).toFixed(1)
                }}</span>
                <span>%</span>
              </artmisads-button>
            </div>
          </div>
          </div>
          <div class="bottom">
            <div class="bottom-title">{{ $t('seller.brandsPage.importantNotice') }}</div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />
              <div v-if="configs.activeTab == '0'">
                <p class="paragraph">
                  {{ $t('seller.brandsPage.setCommissionNoticeP1') }}
                </p>
                <p class="paragraph" style="margin: 16px 0">
                  {{ $t('seller.brandsPage.setCommissionNoticeP2') }}
                </p>
                <p class="paragraph">
                  {{ $t('seller.brandsPage.setCommissionNoticeP3') }}
                </p>
              </div>
              <div v-if="configs.activeTab == '1'">
                <p class="paragraph">
                  {{ $t('seller.brandsPage.activateNoticeBrandP1Before')
                  }}<span class="bold"> {{ $t('seller.brandsPage.activateNoticeBrandP1Bold') }}</span>{{ $t('seller.brandsPage.activateNoticeBrandP1After') }}
                </p>
                <p class="paragraph" style="margin: 16px 0">
                  {{ $t('seller.brandsPage.activateNoticeBrandP2Before')
                  }}<span class="bold"> {{ $t('seller.brandsPage.activateNoticeBrandP2Bold') }} </span>{{ $t('seller.brandsPage.activateNoticeBrandP2After') }}
                </p>
                <p class="paragraph">
                  {{ $t('seller.brandsPage.activateNoticeBrandP3Before')
                  }}<span class="bold"> {{ $t('seller.brandsPage.activateNoticeBrandP3Bold') }}</span>{{ $t('seller.brandsPage.activateNoticeBrandP3After') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </artmisads-modal>
    </template>
  </div>
  <div
    class="update-brand-profile"
    ref="profile"
    v-show="configs.modalType == 'updateProfile'"
  >
    <template>
      <artmisads-modal
        v-model:open="configs.open"
        :getContainer="() => $refs.profile"
        @ok="onOk"
        :title="$t('seller.brandsPage.updateBrandProfile')"
     style="width: 900px"
      >
        <template #footer>
          <div class="footer-btn">
            <artmisads-button
              key="back"
              type="primary"
              @click="onOk"
              :disabled="isDisabled"
              >{{ $t('seller.brandsPage.save') }}</artmisads-button
            >
          </div>
        </template>
        <div class="content">
          <a-form
            :label-col="{ style: { width: '60px' } }"
            :wrapper-col="{ span: 20 }"
            layout="horizontal"
            style="color: aquamarine"
          >
            <a-form-item :label="$t('seller.brandsPage.formImage')">
              <UploadImage
                :configs="{
                  maxCount: 1,
                  maxSize: 2,
                  spin: true,
                }"
                :needCropper="false"
                @upload-file="uploadImg"
                #content
              >
                <div class="upload_part">
                  <div class="upload">
                    <div v-if="brandProfile.logoImageUrl" class="upload-img">
                      <img :src="imgCache(brandProfile.logoImageUrl)" alt="" />
                    </div>
                    <div v-else class="upload-icon">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-shangchuan-xi"></use>
                      </svg>
                    </div>
                  </div>
                  <artmisads-select-button
                    size="small"
                    v-if="brandProfile.logoImageUrl"
                    >{{ $t('seller.brandsPage.replaceImage') }}</artmisads-select-button
                  >
                </div>
              </UploadImage>
              <div class="suggested">{{ $t('seller.brandsPage.suggestedImageSize') }}</div>
            </a-form-item>
            <a-form-item :label="$t('seller.brandsPage.formBio')">
              <a-textarea
                :rows="4"
                maxLength="1000"
                :placeholder="$t('seller.common.pleaseEnter')"
                v-model:value="brandProfile.biography"
                @change="onBios"
                @blur="onValiadBios"
              />
              <span v-show="biosValid" style="color: #eb4e3d"
                >{{ $t('seller.brandsPage.maxWordCount1000') }}</span
              >
            </a-form-item>
          </a-form>
        </div>
      </artmisads-modal>
    </template>
  </div>
</template>
<script setup name="tableModal">
import { ref, reactive, toRefs, computed, watch, watchEffect } from 'vue'
import { message } from 'ant-design-vue'
import { imgCache } from '~/utils'
import Status from '@/components/Status.vue'
import Icon from '@/components/Icon.vue'

import {
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  PauseOutlined,
  CloudUploadOutlined,
} from '@ant-design/icons-vue'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_FULL_NAME } from '@/contants/layout'
import { useSystemStore } from '@/storeData/system'
import UploadImage from '@/components/uploadImage.vue'
import { useI18n } from 'vue-i18n'
import { productsApi, brandApi } from '@/server/index'
const { configs, item } = defineProps({
  configs: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
})
const emit = defineEmits(['cancel', 'ok'])
const user = useUserInfoStore()
const mod = ref()
const profile = ref()
const act = ref()
let nameChecked = ref()
const brandProfile = reactive({})
const isDisabled = ref(true) //按钮禁用
let biosValid = ref(false)
const country = computed(() => {
  return COUNTRY_FULL_NAME[user.userInfo.countryCode]
})
const { t, locale } = useI18n()
watch([() => configs.modalType], (newVal) => {
  if (newVal == 'updateProfile') {
    Object.assign(brandProfile, item)
  }
})
const feesTooltipText = computed(() => {
  locale.value
  const d = defaultCommission.value
  if (d.platformType === 'multiply') {
    return t('seller.setPublicCommission.feesTooltipMultiply', {
      factor: d.platformFeeFactor,
    })
  }
  return t('seller.setPublicCommission.feesTooltipFixed', {
    factor: d.platformFeeFactor,
  })
})
const commission=ref('')
function commissionBlur(e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data
}
const defaultCommission = ref({
  defaultCommissionRate: 1,
  platformFeeFactor: 1,
  platformMaxFeeRate: 1,
})
const fees = computed(() => {
  let value = 0
  if (defaultCommission.value.platformType === 'multiply') {
    if (commission.value) {
      value =
        (commission.value * defaultCommission.value.platformFeeFactor) / 100
    } else {
      value =
        (defaultCommission.value.defaultCommissionRate *
          defaultCommission.value.platformFeeFactor) /
        100
      if (commission.value == 0) {
        value =
          (commission.value * defaultCommission.value.platformFeeFactor) / 100
      }
    }
  } else {
    value = defaultCommission.value.platformFeeFactor
  }

  if (defaultCommission.value.platformType === 'multiply') {
    if (value >= defaultCommission.value.platformMaxFeeRate) {
      value = defaultCommission.value.platformMaxFeeRate
    }
  } else {
    if (value >= defaultCommission.value.platformFeeFactor) {
      value = defaultCommission.value.platformFeeFactor
    }
  }

  let arr = value && value.toString().split('.')
  let firstNumber = arr && Number(arr[0])
  let middleNum = '0'
  if (arr && arr.length > 1) {
    middleNum = Number(arr[1][0])
    if (arr[1][1] == 5) {
      if (arr[1][0] % 2 !== 0) {
        middleNum += 1
        if (arr[1][0] == 9) {
          middleNum = 0
          firstNumber += 1
        }
      }
    } else if (arr[1][1] > 5) {
      middleNum += 1
      if (arr[1][0] == 9) {
        middleNum = 0
        firstNumber += 1
      }
    }
  }
  let endNum = arr && parseFloat(firstNumber + '.' + middleNum)
  return endNum
})
const getRate = async () => {
  const res = await productsApi.getCommissionConfig({
    commissionType: 'attribution',
  })

  const { success, data, error } = res
  if (success) {
    defaultCommission.value = data
  }
}
getRate()
const onModalCancel = (e) => {
  emit('cancel')
}
const uploadImg = (res) => {
  try {
    if (res.data.url !== item.logoImageUrl) {
      isDisabled.value = false
    }
    brandProfile.logoImageUrl = res.data.url
  } catch (error) {
    console.log('upload-false')
  }
}
const onBios = (e) => {
  biosValid.value = false
  if (e.target.value !== item.biography) {
    isDisabled.value = false
  }
}
const onValiadBios = (e) => {
  // if (item.biography.length >= 1000) {
  if (brandProfile.biography && brandProfile.biography.length >= 1000) {
    biosValid.value = true
  }
}
const onOk = (e) => {
  let res = { 
    ...item,
    commission:commission.value
   }
  // if (configs.modalType == "setCommission") {
  //   res.commissionRate = setCommission.commission;
  //   if (!res.commissionRate) {
  //     message.error("please input commission!", 1);
  //     return;
  //   }
  // }
  if (configs.modalType == 'updateProfile') {
    isDisabled.value = true
    if (biosValid.value) {
      return
    }
    res = { ...res, ...brandProfile }
  }
  emit('ok', res)
}
</script>
<style lang="less" scoped>
@space: 16px;

@second-font: {
  opacity: 0.5;
  font-family: Sora, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: var(--dark-1);
  letter-spacing: 0.4px;
  line-height: 22px;
};

.top {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: left;
  .top-left {
  }

  .wenhao {
    fill: var(--dark-4);
  }

  .top-right {
    .top-right-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 15px;
      margin-bottom: 16px;
    }

    .top-right-content {
      display: flex;
      align-items: center;

      .top-right-status-title {
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 14px;
        color: rgba(135, 130, 148, 1);
      }

      .top-right-status-count {
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        margin-left: 4px;
      }

      .top-right-status {
        display: flex;
        align-items: center;
      }

      .top-right-mid {
        width: 2px;
        height: 10px;
        opacity: 1;
        background-color: rgba(232, 229, 237, 1);
        margin: 0 18px;
      }
    }

    .top-right-products {
      display: flex;
      align-items: center;
    }
  }
}

.bottom {
  margin-top: 24px;

  .bottom-title {
    margin-bottom: 14px;
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
  }

  .bottom-content {
    border-radius: 8px;
    background-color: rgba(80, 64, 128, 0.08);
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .tianchong {
    color: rgba(131, 92, 242, 1);
    width: 26px;
    height: 26px;
  }

  .paragraph {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
  }

  .paragraphContent {
    font-family: Sora;
    font-weight: 700;
    font-style: Bold;
    font-size: 13px;
  }

  .bold {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(131, 92, 242, 1);
  }
}

.title-ext {
  @second-font();
  margin-bottom: @space;
}

.modal-title {
  border-radius: 8px 8px 0 0;
  font-family: Sora, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: var(--dark-1);
  letter-spacing: 0.5px;
  line-height: 27px;
  margin-right: 16px;
}

.footer {
  display: flex;
  justify-content: flex-start;
}

.deactive-brand {
  .deactive {
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
    // padding: 24px 17px 24px 24px;
  }
}

.active-brand {
  // padding: 24px 17px 24px 24px;
  .brand-name-row {
    margin-bottom: 8px;
    display: flex;
    flex-wrap: wrap;
  }

  .brand-name {
    font-family: Sora, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 21px;
  }

  .content {
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
  }
  .content-set-commission {
    display: flex;
    flex-direction: column;
    padding-top: 24px;

    .commission {
      display: flex;

      > span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        > span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        > button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          > span {
            align-self: center;
          }
        }
      }

      .fees {
        > button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        > button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }
  }
  // .login-country{
  //   color: #999;
  // }
}

.update-brand-profile {
  :deep(label) {
    @second-font();
    opacity: 0.7;
    font-weight: 500;
    line-height: 20px;
  }

  .upload_part {
    display: flex;
    align-items: flex-end;
  }

  .upload {
    width: 120px;
    height: 120px;
    background: var(--big-bg-1);
    border-radius: 8px;
    margin-right: 8px;

    .upload-icon {
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      @second-font();
      width: inherit;
      height: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 36px;

      &:hover {
        background-color: var(--bg-gray-2);
        border-color: var(--bg-gray-7);
      }
    }

    .upload-img {
      width: 100%;
      height: 100%;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .suggested {
    @second-font();
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-top: 4px;
  }
}

.tip {
  padding: 8px;
  display: flex;
  margin-top: 16px;
  border-radius: 8px;
  color: var(--dark-2);
  background: var(--yellow-3);
  border: 1px solid var(--yellow-8);

  > .iconfont {
    flex: 1;
    height: 16px;
    font-size: 16px;
    min-width: 16px;
    margin-top: 2px;
    margin-right: 8px;
    color: var(--yellow-7);

    &:before {
      display: block;
      margin-top: -4px;
    }
  }
}

.brand-img-show {
  width: 56px;
  height: 56px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  background: var(--bg-gray-2);

  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .brand-name {
    margin: 0 auto;
    padding: 0 4px;
    max-width: 56px;
    font-size: 11px;
    overflow: hidden;
    max-height: 39px;
    font-weight: 600;
    line-height: 13px;
    text-align: center;
    color: var(--dark-4);
    letter-spacing: 0.3px;
  }
}
</style>
